export default __webpack_public_path__ + "static/media/Stage_title.4876c991.png";